import ErrorIcon from '@assets/icons/ErrorIcon';
import { GenericNotification, NotificationTheme } from './GenericNotification';

export const ErrorNotification = ({
  title,
  description,
  theme = 'dark',
}: {
  title: string;
  description: string;
  theme?: NotificationTheme;
}) => {
  return (
    <GenericNotification
      title={title}
      description={description}
      icon={<ErrorIcon className="mr-4" />}
      testId="notifications-error"
      type="error"
      theme={theme}
    />
  );
};
